import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CheckoutService } from '../checkout/checkout.service';

/**
 * Protège l'écran de confirmation de départ.
 *
 * Sans résultat en mémoire, l'écran afficherait « À bientôt, » sans nom et une
 * heure vide. Ce cas se produit à l'accès direct par l'URL et au retour arrière
 * après le retour automatique à l'accueil : on renvoie à l'accueil.
 */
export const checkoutResultGuard: CanActivateFn = () => {
  const checkoutService = inject(CheckoutService);
  const router = inject(Router);

  if (checkoutService.result()) {
    return true;
  }

  return router.createUrlTree(['/']);
};
